import { sendGet } from '../../util/api'

const state = {
  organizationList: []
}

const getters = {
  organizationList: state => state.organizationList,
}

const actions = {
  getOrganizationList({ commit }) {
    return new Promise((resolve, reject) => {
      sendGet('organizations')
        .then((response) => {
          resolve(response)
          const organizations = response.results.map(item => item)
          commit('SET_ORGANIZATION_LIST', organizations)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

const mutations = {
  SET_ORGANIZATION_LIST(state, data) {
    state.organizationList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}